<template lang="html">
  <EmptyResourceNotification v-if="resource.children_ids.length < 1" :resource="resource" />
  <div v-else class="timeline container">
    <div class="timeline__wrapper">
      <div
        v-if="resource.columns.title"
        v-editable="resource.columns.title"
        class="timeline__title"
      />
      <div class="timeline__box">
        <TimelineItem v-for="item in children" :key="item.id" :resource="item" />
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import EmptyResourceNotification from 'beisheim/components/elements/empty-resource-notification'
import TimelineItem from 'beisheim/components/blocks/timeline-item'
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  components: {
    TimelineItem,
    EmptyResourceNotification
  },
  mixins: [ editable ],
  computed: {
    children () {
      return sortBy(this.resource.children, 'sort_key')
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/grid';

  .timeline {
    display: block;
    margin-top: scale(12);
    padding-top: scale(10);

    &:after {
      content: "";
      clear: both;
      display: table;
    }

    &__wrapper {
      border-top: 1px solid gray(4);
      padding-top: 2.9rem;
      @include from(4) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }

    &__title {
      font-size: font-size(1);
      margin-bottom: scale(8);
    }

    &__box {
      flex-direction: column;
      margin: scale(11) 0 0 0;
      width: 50%;
      float: right;
      position: relative;

      @include from(4) {
        display: flex;
        width: auto;
        float: none;
      }

    }

    &__container {
      padding-bottom: scale(8);
      width: grid-columns(10);
      position: relative;

      @include from(4) {
        width: grid-columns(6);
      }

      &:first-child {

        &:before {
          content: ' ';
          height: scale(10);
          width: 2px;
          background: #ccc;
          display: block;
          position: absolute;
          right: -2px;
          top: 0;
          transform: translateY(-100%);
        }

        &:after {
          content: ' ';
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background: #aaa;
          position: absolute;
          display: block;
          right: -5px;
          top: 0;
          transform: translateY(scale(-10));
        }

      }

      &:last-child {
        padding-bottom: scale(20);
      }

      &:nth-child(even) {
        @include grid-spacing(padding-left, 1);
        border-left: 2px solid #ccc;

        .timeline__year {
          &:before {
            left: 0;
            transform: translateX(-55%);
          }
        }

      }

      &:nth-child(odd) {
        transform: translateX(-99.5%);
        @include grid-spacing(padding-right, 1);
        text-align: right;
        border-right: 2px solid #ccc;

        .timeline__year {
          &:before {
            right: 0;
            transform: translateX(55%);
            background: #ccc;
          }
        }

      }
    }

    &__year {
      display: block;
      font-size: font-size(1);
      margin-top: -7px;

      &:before {
        content: ' ';
        width: 15px;
        height: 15px;
        background: #aaa;
        border-radius: 50%;
        display: block;
        top: -2px;
        position: absolute;
      }
    }

    &__text {
      display: block;
    }
  }

</style>
